import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import css from 'styles/components/account/vipDashboard/vipOptIn.scss';

const VipOptIn = ({ onSignUp }) => (
  <div>
    <div className={css.terms}>
      <h2>Join Zappos VIP</h2>
      <p>
      You'll get FREE Next Business Day Shipping, earn points redeemable for VIP Codes, enjoy fast refunds, and so much more! Plus, it's free and easy to join.
      </p>
      <form method="post" onSubmit={onSignUp}>
        <div className={css.termsCheckbox}>
          <input type="checkbox" id="rewardsTerms" required/>
          <label htmlFor="rewardsTerms">I agree to the Terms &amp; Conditions</label>
        </div>

        <MartyLink to="/rewards-terms-of-use">Read The Terms &amp; Conditions</MartyLink>

        <div className={css.buttonRow}>
          <div className={css.signUpButton}>
            <button type="submit">Sign Up For Zappos VIP</button>
          </div>
          <div className={css.learnMoreButton}>
            <MartyLink to="/zappos-rewards/">Learn More</MartyLink>
          </div>
        </div>

        <MartyLink
          className={css.readFaqLink}
          to="/c/rewards-faq"
          data-track-action="Action"
          data-track-label="Loyalty"
          data-track-value="GotoQuestions">
            Have Questions? Read The FAQs.
        </MartyLink>
      </form>
    </div>
  </div>
);

VipOptIn.contextTypes = {
  testId: PropTypes.func
};

VipOptIn.propTypes = {
  onSignUp: PropTypes.func.isRequired
};

export default VipOptIn;
